import { render, staticRenderFns } from "./IdAndAccount.vue?vue&type=template&id=e0422fa0&scoped=true"
import script from "./IdAndAccount.vue?vue&type=script&lang=js"
export * from "./IdAndAccount.vue?vue&type=script&lang=js"
import style0 from "./IdAndAccount.vue?vue&type=style&index=0&id=e0422fa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0422fa0",
  null
  
)

export default component.exports